<script setup>
//#region props
import { computed } from 'vue';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: () => false,
  },
  showAfter: {
    type: Number,
    default: () => 300,
  },
  placement: {
    type: String,
    default: () => 'top',
  },
  tooltip: {
    type: String,
    default: () => '',
  },
  isHtml: {
    type: Boolean,
    default: () => false,
  },
  popoverClass: {
    type: String,
    default: () => '',
  },
});
//#endregion

const emit = defineEmits(['click']);

//#region computed
const isEmptyContent = computed(() => {
  return props.tooltip.trim() === '';
});
const pPopoverClass = computed(() => {
  const classes = ['ui-tooltip__popper', props.popoverClass];
  return classes.join(' ');
});
//#endregion
</script>
<template>
  <ElTooltip
    class="ui-tooltip"
    :show-after="showAfter"
    :placement="placement"
    :content="tooltip"
    :raw-content="isHtml"
    :disabled="isEmptyContent || disabled"
    :popper-class="pPopoverClass"
  >
    <slot />
  </ElTooltip>
</template>

<style lang="scss">
.ui-tooltip{
  z-index: 10001 !important;
  &__popper {
    color: var(--text-body-invert);
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    padding: 8px 12px;
    border-radius: 8px;
    background: var(--overlay-black-80);
    max-width: 450px;
  }
}
</style>
